export default "__VITE_ASSET__DvAlzifS__"